import * as React from "react";
import { Table, InputNumber, Button, Space, Result, Spin } from "antd";
import { ColumnsType } from "antd/lib/table";
import { RouteComponentProps } from "react-router-dom";
import * as SendReceiptStore from "../store/SendReceipt";
import { ApplicationState } from "../store";
import { connect } from "react-redux";
import * as IssuedOrderStore from "../store/IssuedOrder";

// At runtime, Redux will merge together...
type SendReceiptProps =
    SendReceiptStore.SendReceiptState // ... state we've requested from the Redux store
    & typeof SendReceiptStore.actionCreators // ... plus action creators we've requested
    & RouteComponentProps<{ selectedOrderNumber: string }> // ... plus incoming routing parameters
    & { orderIntake: IssuedOrderStore.IssuedOrderState }; // extra props


const SendReceipt = (props: SendReceiptProps) => {
    const orderIntakeProps = props.orderIntake;

    const orderNumberUrlParam = props.match.params.selectedOrderNumber;
    const orderNumberState = orderIntakeProps?.issuedOrder?.Number || "0";
    const sendReceipt = props.sendReceipt;

    React.useEffect(() => {
        if (orderIntakeProps?.issuedOrder && orderIntakeProps) {
            sendReceipt(orderIntakeProps.issuedOrder, orderIntakeProps.receivedItems);
        }
    }, [orderNumberUrlParam, orderNumberState, sendReceipt]); // send receipt on mount

    return <div>
        {
            props.isSending &&
            <Result
                icon={<Spin />}
                title={"Vytvára sa príjemka ..."}
            />
        }      
        {
            props.isSentSuccessfully &&
            <Result
                status="success"
                title={"Tovar od " + props.newReceiptCompanyName + " úspešne prijatý!"}
                subTitle={`Príjemka má číslo ${props.newReceiptNumber}.`}
                extra={[
                    <Button type="primary" key="list" size="large" onClick={() => props.history.push("/order-intake")}>
                        Prejsť na zoznam objednávok
                    </Button>,
                ]}
            />
        }
        {
            props.error &&
            <Result
                status="error"
                title={"Tovar od " + orderIntakeProps?.issuedOrder?.CompanyName + " sa nepodarilo prijať!"}
                subTitle={props.error}
                extra={[
                    <Button type="primary" key="back" size="large" onClick={() => props.history.goBack()}>
                        Späť
                    </Button>,
                    <Button type="default" key="list" size="large" onClick={() => props.history.push("/order-intake")}>
                        Prejsť na zoznam objednávok
                    </Button>
                ]}
            />
        }
        
    </div>
}

export default connect((state: ApplicationState) => ({
    ...state.sendReceipt,
    orderIntake: state.orderIntake
}), SendReceiptStore.actionCreators)(SendReceipt as any);